import { AuthorFields, calcDateSpanDescription, Document, FullAuthored, FullPost } from 'model';
import React from 'react';
import { ProfilePic } from './ProfilePic';
// eslint-disable-next-line css-modules/no-unused-class
import shareStyles from '../styles/Shared.module.css';
import styles from './AuthorHeaderQuestion.module.css';

export const AuthorHeaderQuestion = <T extends Document & AuthorFields>({
	authoredItem
}: {
	authoredItem: FullPost;
}): ReturnType<React.FC<{ author: FullAuthored<T> }>> => {
	return (
		<div className={styles.authorHeader}>
			<ProfilePic user={authoredItem.fullAuthor} size={'tiny'} />
			<div className={styles.authorHeaderDetailsContainer}>
				<div className={styles.nameCommentCountContainer}>
					<div className={styles.name}>
						{authoredItem && authoredItem.author && authoredItem.fullAuthor.username}
					</div>
				</div>
				<div className={styles.dateContainer}>
					<span className={shareStyles.time}>{calcDateSpanDescription(authoredItem.updated)}</span>
				</div>
			</div>
		</div>
	);
};
